import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListView } from '../core/ListViewProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { useAuth } from '../../../../auth'
import { temVinculoMedicoAtivo } from 'app/modules/auth/core/vinculos'
import { FormularioAtendimentoList } from '../core/_models'
import { avaliacoesPendentesColumns } from './columns/_columns'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { IconPaths } from '../../../../../../_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'

export const AvaliacoesPendentesTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { selected } = useListView()
  const { hasFilters, clearFilters } = useListFilters()
  const { currentUser } = useAuth()
  const isMedico = temVinculoMedicoAtivo(currentUser?.vinculos)
  const { t } = useT()

  const columns = useMemo(() => avaliacoesPendentesColumns(t, isMedico), [t, isMedico])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhuma avaliação encontrada'
      description={`Revise o paciente, o protocolo ou a ${t('empresa.label.lowercase')}.`}
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      icon={IconPaths.Check}
      title='Nenhuma avaliação pendente'
      description='As avaliações finalizadas sob sua responsabilidade aparecem aqui para assinar.'
    />
  )

  return (
    <CustomTable<FormularioAtendimentoList>
      id='kt_table_avaliacoes_pendentes'
      ariaLabel='Avaliações pendentes de assinatura'
      itemLabel={{ singular: 'avaliação', plural: 'avaliações' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      isRowSelected={(row) => selected.some((s) => s.formularioAtendimentoId === row.id)}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
